import { Form } from '@ant-design/compatible'

// import '@ant-design/compatible/assets/index.css';

import { Checkbox, Input, Modal, Select } from 'antd'
import { customAlphabet } from 'nanoid'
import PropTypes from 'prop-types'
import React from 'react'
import { invitationUsesValidator } from '../../dux/actions/utils/helpers'
import InvitationAccessFields, {
  approvalFieldDefaults,
  readApprovalFields,
} from './InvitationAccessFields'

const FormItem = Form.Item
const nanoid = customAlphabet(
  '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
  7,
)

class AddInvitationModal extends React.Component {
  state = {
    inviteCode: nanoid(),
  }

  saveFormRef = (ref) => (this.form = ref)

  onAdd = () => {
    this.form.validateFields((err, values) => {
      if (!err) {
        const invite = {
          name: values.inviteName,
          id: values.id,
          groups: values.groups,
          valid: true,
          uses: values.uses !== undefined ? parseInt(values.uses, 10) : 0,
          notifyAdmins: !!values.notifyAdmins,
          ...readApprovalFields(values),
          registrations: 0,
          client: this.props.user.client,
          deleted: false,
          created: Date.now(),
        }

        this.props.modalProps.onSubmit(invite)
      }
    })
  }
  render() {
    return (
      <Modal
        title="Add Invitation Code"
        okText="SAVE"
        onOk={this.onAdd}
        cancelText="Cancel"
        onCancel={this.props.modalActions.closeModal}
        open={this.props.modal.modalOpen}
        confirmLoading={this.props.appState.asyncPending}
        maskClosable={false}
      >
        <AddInvitationForm
          ref={this.saveFormRef}
          groups={this.props.modalProps.groups}
          code={this.state.inviteCode}
        />
      </Modal>
    )
  }
}

const AddInvitationForm = Form.create()((props) => {
  const { form } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form
  const { Option } = Select

  const [limitUses, setLimitUses] = React.useState(true)

  const handleLimitCheckboxChange = (e) => {
    const checked = e.target.checked
    setLimitUses(checked)
    if (!checked) {
      setFieldsValue({ uses: 0 })
    }
  }

  return (
    <Form layout="vertical">
      <FormItem label="Invitation Name" require={true}>
        {getFieldDecorator('inviteName', {
          initialValue: '',
          rules: [
            {
              required: true,
              message: 'Invitation Name is required',
            },
          ],
        })(<Input />)}
      </FormItem>
      <FormItem
        label="Group"
        help={
          'Users that register with this invitation will be automatically added to selected groups.'
        }
      >
        {getFieldDecorator('groups', {
          initialValue: undefined,
          rules: [
            {
              required: true,
              message: 'At leaset one group is required',
            },
          ],
        })(
          <Select
            mode="multiple"
            defaultActiveFirstOption={false}
            placeholder="Add one or more groups"
            filterOption
            optionFilterProp="name"
          >
            {props.groups
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((group) => (
                <Option key={group.id} value={group.id} name={group.name}>
                  {group.name}
                </Option>
              ))}
          </Select>,
        )}
      </FormItem>
      <FormItem label="Limit Uses">
        <Checkbox checked={limitUses} onChange={handleLimitCheckboxChange} />
      </FormItem>
      {limitUses && (
        <FormItem label="Max Uses">
          {getFieldDecorator('uses', {
            validateTrigger: 'onBlur',
            initialValue: 1,
            rules: [
              {
                validator: invitationUsesValidator,
              },
            ],
          })(<Input type="number" style={{ width: '100px' }} />)}
        </FormItem>
      )}
      <FormItem
        label="Notify admins on use"
        extra="Email tenant admins each time someone registers with this code and confirms their email"
      >
        {getFieldDecorator('notifyAdmins', {
          valuePropName: 'checked',
          initialValue: false,
        })(<Checkbox />)}
      </FormItem>
      <InvitationAccessFields
        FormItem={FormItem}
        getFieldDecorator={getFieldDecorator}
        getFieldValue={getFieldValue}
        groups={props.groups}
        defaults={approvalFieldDefaults()}
      />
      <FormItem label="Invitation Code">
        {getFieldDecorator('id', {
          initialValue: props.code,
        })(<Input disabled />)}
      </FormItem>
    </Form>
  )
})
/*
 *  Props are from the redux store
 *  "actions" are objects created by bindActionCreators, containing all relevant action functions
 *  modalProps is object passed from modal creator
 */
AddInvitationModal.propTypes = {
  modal: PropTypes.object,
  modalActions: PropTypes.object,
  modalProps: PropTypes.object,
  appState: PropTypes.shape({
    asyncPending: PropTypes.bool,
  }),
  onSubmit: PropTypes.func,
}

AddInvitationModal.defaultProps = {
  modalProps: {},
}

export default AddInvitationModal
